import { render, staticRenderFns } from "./gym_manual_add.vue?vue&type=template&id=4406260b&"
import script from "./gym_manual_add.vue?vue&type=script&lang=js&"
export * from "./gym_manual_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports